import { EBootstrapActions } from 'affiny-core/modules/bootstrap/types';
import { ActionsUnion, createAction } from 'affiny-core/modules/helpers';

/* ***** *****  Actions  ***** ***** */

export const authActions = {
  bootstrapApp: () => createAction(EBootstrapActions.BOOTSTRAP_APP),
};

/* ***** *****  Types  ***** ***** */

export type TAuthAction = ActionsUnion<typeof authActions>;
